import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";

export class RockBottomReelStopPresentationController extends ReelStopPresentationController {
    constructor() {
        super("RockBottomReelStopPresentationController");
    }

    protected onReelStopped(data: IReelStateEventData): Promise<any> {
        //don't do any thing here, some how reel stop order is not correct in restore state
        return super.onReelStopped(data);
    }
}